import React from "react";
import { InstagramColoredIcon, MonitorIcon } from "assets";
import ProfileCard from "pages/Profile/components/ProfileCard";

const SocialMediaSection = () => {
  return (
    <div className="grid grid-cols-2 gap-2 text-m">
      <ProfileCard className="p-4">
        <div className="flex items-center justify-center gap-2 text-m dark:text-white/90">
          <MonitorIcon />
          Website
        </div>
      </ProfileCard>
      <ProfileCard className="p-4">
        <div className="flex items-center justify-center gap-2 text-m dark:text-white/90">
          <InstagramColoredIcon height={20} width={20} />
          Instagram
        </div>
      </ProfileCard>
    </div>
  );
};

export default SocialMediaSection;
